import gql from 'graphql-tag';

/**
 * Mutation to fork an existing inspection template for a specific building.
 * Creates a channel-owned copy of a parent (often global) template so the
 * channel can customize it without mutating the shared template.
 */
export const forkInspectionTemplateMutation = gql`
  mutation ForkInspectionTemplate($input: ForkInspectionTemplateInput!) {
    forkInspectionTemplate(input: $input) {
      templateId
    }
  }
`;
